import { render, staticRenderFns } from "./TheChatPreview.vue?vue&type=template&id=7ffd71f2"
import script from "./TheChatPreview.vue?vue&type=script&lang=js"
export * from "./TheChatPreview.vue?vue&type=script&lang=js"
import style0 from "./TheChatPreview.vue?vue&type=style&index=0&id=7ffd71f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports